/* ==========================================================
   VARIAÇÃO DE IMAGENS POR CARD - DESATIVADA
   Não duplica mais cards do mesmo produto, então não precisa
   trocar imagem por cor.
   ========================================================== */
(function () {
  'use strict';
  // Script desativado intencionalmente.
  // Cada card mostra sua imagem default (featured_image do produto).
})();
